var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import styled from 'styled-components';
export var SpaceFillingDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   display: flex;\n   flex: 1;\n"], ["\n   display: flex;\n   flex: 1;\n"])));
var AutoSizerImplementation = function (_a) {
    var disableHeight = _a.disableHeight, disableWidth = _a.disableWidth, onResize = _a.onResize, children = _a.children;
    return (React.createElement(SpaceFillingDiv, null,
        React.createElement(AutoSizer, { disableHeight: disableHeight, disableWidth: disableWidth, onResize: onResize }, children)));
};
export default AutoSizerImplementation;
var templateObject_1;
//# sourceMappingURL=AutoSizerImplementation.js.map